import React from 'react'
import { Query } from 'react-apollo';
import { useIntl } from 'react-intl';
import { useFormikContext } from 'formik';
import { citiesQuery } from './query';
import { PLACEHOLDER_MESSAGES_STEP1 } from '../../constants';
import MultiSelect from '../../../../../../../../../utils/components/MultiSelect';
import "./styles/CitySelect.scss";

const CitySelect = ({ name, updateField }) => {
  const intl = useIntl();
  const { values: { cityProject, countryProject } } = useFormikContext();
  
  return (
    <Query 
    query={citiesQuery}
    variables={{ countryId: countryProject[0]?.value }}
    >
      {({ loading, data, error, refetch })  => { 
        const citiesList = data?.cities?.edges?.map(({ node }) => ({
          id: node.id,
          value: node.id,
          label:  `${node.name}, ${node.region?.name}`,
        })) || [];

        const handleRefetch = (cityName) => {
          refetch({
            search: cityName,
          })
        }

        if (error) {
          const {graphQLErrors, networkError} = error;
          if (graphQLErrors || networkError) {
            console.error("Error fetching cities GraphQL:", graphQLErrors);
            console.error("Error fetching cities Network:", networkError);
          }
        }
        
        return (
          <MultiSelect
            className="city-select--step1"
            config={{
              name,
              initialValues: cityProject,
              selectValues: citiesList,
              disabled: loading || !countryProject,
              placeholderMessage: intl.formatMessage(PLACEHOLDER_MESSAGES_STEP1["cityProject"]),
              disabledPlaceholder: intl.formatMessage({ id: "ProjectStepForm.cities.firstSelectCountry" }),
            }}
            isOnlyOneOption
            updateField={updateField}
            onFilterChange={handleRefetch}
          />
        );      
      }}
    </Query>
  )
}

export default CitySelect;
